import React, { useMemo } from "react";
import { arrayOf, bool, func, shape, string } from "prop-types";
import { compose } from "redux";
import { connect } from "react-redux";
import { push } from "react-router-redux";

import { resizableRoute } from "pages/_components/Resizable";
import { actions, selectors } from "reducers/paymentsAFIP";
import { actions as servicePaymentsActions } from "reducers/servicePayments";
import { actions as globalActions } from "reducers/types/global";
import * as i18n from "util/i18n";
import { TicketVepMultiple, Box, Spinner } from "@ui-kit/components/index.es";
import Notification from "pages/_components/Notification";
import { FORM_TICKET } from "constants/servicePayments";
import { getAccountDescription } from "util/accounts";
import { getServicePaymentsPath } from "util/servicePaymentsRoutes";
import { CURRENCY_CODE, getCurrencyByCode } from "constants.js";
import Head from "pages/_components/Head";

function PaymentsMultipleArcaTransaction(props) {
    const { isDesktop, dispatch, debitAccount, afipList, embeddedInV3Shell, isFetching } = props;

    const handleBack = () => {
        dispatch(servicePaymentsActions.setPaymentSelected());
        dispatch(actions.cleanPaymentsAfip());
        dispatch(push(getServicePaymentsPath()));
    };

    const parseVepAmountForTotals = (amount) => {
        const parsed = Number.parseFloat(
            String(amount ?? "")
                .trim()
                .replace(/\./g, "")
                .replace(",", "."),
        );

        return Number.isFinite(parsed) ? parsed : 0;
    };

    const summarizeVepConfirmationGroups = (groups) => {
        const rows = ["own", "thirdparty", "taxpayer"].flatMap((key) => groups?.[key] || []);

        return {
            totalAmount: rows.reduce((acc, row) => acc + parseVepAmountForTotals(row.amount), 0),
            totalCount: rows.length,
        };
    };

    const { totalAmount: totalVepAmountResolved, totalCount: totalVepCountResolved } = useMemo(
        () => summarizeVepConfirmationGroups(afipList),
        [afipList],
    );

    return (
        <>
            {!embeddedInV3Shell && <Notification scopeToShow="multipleAFIPSuccess" />}
            {!embeddedInV3Shell && !isDesktop && (
                <div className="admin-detail-head px-0 mb-0">
                    <Head
                        title={i18n.get(`${FORM_TICKET}.confirmationTicket.title`)}
                        isFetchingExport={false}
                        onBack={!isDesktop ? handleBack : undefined}
                        headerClassName={
                            !isDesktop ? "blue-main-header-mobile servive-payment-title-mobile" : undefined
                        }
                    />
                </div>
            )}
            {isFetching ? (
                <Box flex justify="center" align="center" column py={72}>
                    <Spinner size="large" />
                </Box>
            ) : (
                <Box pt={isDesktop ? 0 : 20}>
                    <TicketVepMultiple
                        ticket={{
                            transactionDate: Date.now(),
                            debitAccount: debitAccount?.number && getAccountDescription(debitAccount),
                            totalAmount: totalVepAmountResolved,
                            currency: getCurrencyByCode(CURRENCY_CODE, debitAccount?.currency),
                            quantity: totalVepCountResolved,
                        }}
                        getLabels={(key) => i18n.get(`${FORM_TICKET}.confirmationTicket.${key}`)}
                        handleGoBack={handleBack}
                        handleGoToHistory={() => {
                            dispatch(globalActions.resetSelectedElements());
                            dispatch(push("/transactions/list"));
                        }}
                        handleGoToPayServices={handleBack}
                    />
                </Box>
            )}
        </>
    );
}

PaymentsMultipleArcaTransaction.propTypes = {
    isDesktop: bool,
    dispatch: func.isRequired,
    debitAccount: shape({
        idProduct: string.isRequired,
    }).isRequired,
    afipList: arrayOf(shape({})).isRequired,
    isFetching: bool.isRequired,
    embeddedInV3Shell: bool,
};

PaymentsMultipleArcaTransaction.defaultProps = {
    isDesktop: false,
    embeddedInV3Shell: false,
};

const mapStateToProps = (state) => ({
    afipList: selectors.getVepSelectedList(state),
    debitAccount: selectors.getDebitAccountMultipleVep(state),
    isFetching: selectors.getFetching(state),
});

export default compose(connect(mapStateToProps), resizableRoute)(PaymentsMultipleArcaTransaction);
